import {match} from 'ts-pattern';

import {UserMailboxProvider} from '@dms/api/core';
import i18n from '@dms/i18n';

export function getProviderLabel(provider: UserMailboxProvider): string {
  return match(provider)
    .with('google', () => i18n.t('page.myProfile.receivingMailbox.provider.google'))
    .with('microsoft', () => i18n.t('page.myProfile.receivingMailbox.provider.microsoft'))
    .with('imap', () => i18n.t('page.myProfile.receivingMailbox.provider.imap'))
    .exhaustive();
}
